module.exports = __webpack_public_path__ + "media/v_coffeeshop.1e6ece09.mp4";